import { render } from "./Group.vue?vue&type=template&id=63332c88&ts=true"
import script from "./Group.vue?vue&type=script&lang=ts"
export * from "./Group.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/askom/io.askom.portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__